"use client";

import {
  HeroSection,
  PersonasSection,
  FeaturesBubblesSection,
  AgenticOperationsSection,
  StatsSection,
  TestimonialsSection,
  MissionShowcaseSection,
  ServicesSection,
} from "@/components/sections/home";

/**
 * Composes the marketing homepage sections.
 * Copy lives in locale home.json files (Blob + static fallback via getMessages).
 */
export default function HomePage() {
  return (
    <>
      <HeroSection />
      <PersonasSection />
      <FeaturesBubblesSection />
      <AgenticOperationsSection />
      <StatsSection />
      <TestimonialsSection />
      <MissionShowcaseSection />
      <ServicesSection />
    </>
  );
}
